module.exports = __webpack_public_path__ + "img/nav-toggle-icon.caa0cf7d.svg";